// Helpers shared by the Atribución screen.

// Fixed colours per traffic source, as in the CrmB mockup.
const SOURCE_COLOR = {
  facebook: '#4573d2',
  instagram: '#c2478a',
  google: '#e0900d',
  adwords: '#e0900d',
  tiktok: '#1d2b36',
  email: '#2f6fae',
  whatsapp: '#1b8f7f',
  directo: '#8b9aa6',
  direct: '#8b9aa6',
};

export const sourceColor = source =>
  SOURCE_COLOR[String(source || '').toLowerCase()] || '#8b9aa6';

// The UTM keys a campaign code carries, in the order the builder shows them.
export const UTM_FIELDS = ['source', 'medium', 'campaign', 'term', 'content'];

/**
 * Builds the tracking URL for a campaign: the landing page plus its UTM
 * parameters and the code itself as `utm_id`, which is what the contact
 * lands with and what `campaign_code` is matched against later.
 */
export const buildTrackingUrl = (baseUrl, utms = {}, code = '') => {
  const trimmed = String(baseUrl || '').trim();
  if (!trimmed) return '';

  const withProtocol = /^https?:\/\//i.test(trimmed)
    ? trimmed
    : `https://${trimmed}`;
  let url;
  try {
    url = new URL(withProtocol);
  } catch {
    return '';
  }

  UTM_FIELDS.forEach(field => {
    const value = utms?.[field];
    if (value) url.searchParams.set(`utm_${field}`, value);
  });
  if (code) url.searchParams.set('utm_id', code);

  return url.toString();
};

// "hace 2 h" / "28 ago" for the "último uso" column.
export const relativeOrDate = (timestamp, locale) => {
  if (!timestamp) return '';
  const seconds = Math.round(timestamp - Date.now() / 1000);
  const abs = Math.abs(seconds);
  if (abs < 60 * 60 * 24 * 7) {
    const rtf = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' });
    if (abs < 3600) return rtf.format(Math.round(seconds / 60), 'minute');
    if (abs < 86400) return rtf.format(Math.round(seconds / 3600), 'hour');
    return rtf.format(Math.round(seconds / 86400), 'day');
  }
  return new Intl.DateTimeFormat(locale, {
    day: 'numeric',
    month: 'short',
  }).format(new Date(timestamp * 1000));
};

// Percentage of a total, guarding against a zero denominator.
export const percentOf = (value, total) =>
  total > 0 ? Math.round((Number(value) / total) * 100) : 0;
